export default "__VITE_ASSET__Ck6rA5OS__"